import { maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoTimeOptionsGenerator } from '@maskito/kit';
import { useMaskito } from '@maskito/react';
import { Input, InputProps } from '@e2n/ui';

interface TimeInputProps extends InputProps {
  className?: string;
  onClick?: () => void;
}
const timeOptions = maskitoTimeOptionsGenerator({
  mode: 'HH:MM',
  timeSegmentMaxValues: { hours: 23 },
});

const options = {
  ...timeOptions,
  plugins: [
    ...timeOptions.plugins,
    maskitoEventHandler('blur', (element) => {
      const [hours = '', minutes = ''] = element.value.split(':');

      if (hours === '' && minutes === '') {
        return;
      }

      maskitoUpdateElement(
        element,
        [hours, minutes].map((segment) => segment.padEnd(2, '0')).join(':'),
      );
    }),
  ],
};

export function TimeInput({ className, ...props }: TimeInputProps) {
  const maskedInputRef = useMaskito({ options });

  return <Input {...props} ref={maskedInputRef} className={className} />;
}
